import { DeviceThermostatRounded } from '@mui/icons-material';
export const vehicle_thermometer_definitions = {
    cabin: {
        label: 'Салон',
        Icon: undefined,
    },
    engine: {
        label: 'Двигатель',
        Icon: undefined,
    },
    outside: {
        label: 'Снаружи',
        Icon: DeviceThermostatRounded,
    },
    none: {
        label: 'Датчик',
        Icon: undefined,
    },
};
export function getVehicleThermometersConfig(device) {
    const { temperature_conf, temperature } = device;
    const temperature_configs = temperature_conf?.assignments;
    if (!temperature || !temperature_configs) {
        return null;
    }
    const shared_thermometers = temperature_configs?.map((config, slot) => {
        const thermometer = temperature[slot];
        if (!thermometer || thermometer.state !== 'ok') {
            return null;
        }
        if (config === 'none') {
            return null;
        }
        return {
            id: slot,
            name: vehicle_thermometer_definitions[config].label,
        };
    });
    return shared_thermometers;
}
